import { sortOptionsISelect } from "../helpers/sortISelect";
import { phoneType } from "../model/enumerations/phone-type.model";
import { ISelect } from "../model/iSelect";

export const phoneTypeEnum = (): Array<ISelect> => {
  const phoneTypes: Array<ISelect> = [
    {
      label: phoneType.Movil,
      value: phoneType.Movil,
    },
    {
      label: phoneType.Fijo,
      value: phoneType.Fijo,
    },
  ];
  return sortOptionsISelect(phoneTypes);
};